const API_BASE = process.env.REACT_APP_BACKEND_URL || 'https://tvs-api.chatup.pe';

export const TVs = {
  getTvs: async () => {
    const r = await fetch(`${API_BASE}/api/pantallas/tv`, {
      headers: { 'Cache-Control': 'no-cache' }
    });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return r.json();
  },
  getTvById: async (id) => {
    const r = await fetch(`${API_BASE}/api/pantallas/tv/${id}`);
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return r.json();
  },
  createTv: async (data) => {
    const r = await fetch(`${API_BASE}/api/pantallas/tv`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return r.json();
  },
  updateTv: async (id, data) => {
    const r = await fetch(`${API_BASE}/api/pantallas/tv/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return r.json();
  },
  deleteTv: async (id) => {
    const r = await fetch(`${API_BASE}/api/pantallas/tv/${id}`, { method: 'DELETE' });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return r.json();
  },
};
